module.exports = __webpack_public_path__ + "static/github-profile-70b7f54d3c93743fe6df1532e3864630.png";